exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._20YFajYdbQlnQjTM22xocg {\n  position: relative;\n  display: inline-flex;\n}\n", ""]);

// Exports
exports.locals = {
	"resourceRequestNavButtonContainer": "_20YFajYdbQlnQjTM22xocg"
};